export default "__VITE_ASSET__B_ElD1in__"